<template>
  <div class="d-flex-row space-between lg-row-to-col">
    <FaceitRankPicker
      :type="'faceitCurrentDivision'"
      item-key="faceitDivisionBoosting"
      :title="$t('calculators_common.current_division')"
      :show-value-setter="false"
      class="flex-5 flex-lg-10"
    />
    <FaceitRankPicker
      :type="'faceitDesiredDivision'"
      item-key="faceitDivisionBoosting"
      :title="$t('calculators_common.current_division')"
      :prev-rank="getDetails.faceitCurrentDivision"
      :show-value-setter="false"
      class="flex-5 flex-lg-10"
    />
  </div>
  <OptionPicker />
</template>

<script setup>
import FaceitRankPicker from "./pickers/FaceitRankPicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import { onMounted, computed, watch } from "vue";
const {
  getDetails,
  setDetails,
  setPlatform,
  setGameAndPack,
  clearCheckout,
  setCalculating,
  removePackOption,
  setPackOptions,
  getPackOptions,
} = useCheckoutStore();
const { getGame, getGamePack } = useGameStore();
const duoQOption = computed(() => {
  const option = getGamePack?.pack_options?.find(
    (option) => option.const_title === "self_play"
  );
  if (option) {
    return option;
  }
  return null;
});

const isOptionSelected = (packOption) => {
  const selectedOption = getPackOptions.find((option) => option === packOption);
  if (!selectedOption) {
    return false;
  }
  return true;
};

const selectOption = (option) => {
  try {
    removePackOption({
      optionIds: option?.rules?.disable || [],
    });
    setPackOptions({
      options: [option.id],
    });
  } catch (error) {
    console.log(error);
  }
};

const handleDetails = () => {
  clearCheckout();
  // if (duoQOption.value) {
  //   selectOption(duoQOption.value);
  // }

  setDetails({
    currentDivisionTitle: "Level 1",
    desiredDivisionTitle: "Level 2",
    faceitCurrentDivision: 639,
    faceitDesiredDivision: 640,
    rankFrom: 100,
    rankTo: 501,
  });

  setPlatform({
    platform: 1,
  });

  setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();

onNuxtReady(() => {
  setCalculating();
});

watch(duoQOption, (newVal) => {
  if (newVal.id) {
    selectOption(newVal);
  }
});
</script>
